import PAContactDetailsView from 'text!../views/pa-contact-details.html';
import PAPreQualQuestionsView from 'text!edge/quoteandbind/common/views/prequal-questions.html';
import DriverDetailsView from 'text!../views/pa-driver-details.html';
import VehicleDetailsView from 'text!../views/pa-vehicle-details.html';
import PolicyInfoView from 'text!../views/pa-policy-info.html';
import PAContactDetailsCtrl from '../controllers/PAContactDetailsCtrl';
import PAPreQualQuestionsCtrl from '../controllers/PAPrequalQuestionsCtrl';
import DriverDetailsCtrl from '../controllers/PADriverDetailsCtrl';
import VehicleDetailsCtrl from '../controllers/PAVehicleDetailsCtrl';
import PolicyInfoCtrl from '../controllers/PAPolicyInfoCtrl';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        paContactDetails: {
            parent: wizardParentState,
            template: PAContactDetailsView,
            controller: PAContactDetailsCtrl
        },
        paPrequalQuestions: {
            parent: wizardParentState,
            controller: PAPreQualQuestionsCtrl,
            template: PAPreQualQuestionsView
        },
        paDriverDetails: {
            parent: wizardParentState,
            controller: DriverDetailsCtrl,
            template: DriverDetailsView
        },
        paVehicleDetails: {
            parent: wizardParentState,
            controller: VehicleDetailsCtrl,
            template: VehicleDetailsView
        },
        paPolicyInfo: {
            parent: wizardParentState,
            controller: PolicyInfoCtrl,
            template: PolicyInfoView
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/config/RouteConfig.js
// module id = 2163
// module chunks = 0